import React, { forwardRef } from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import type { ResponsiveParallaxBg } from './plLandingAssets';
import styles from './ResponsiveParallaxBackgroundImages.module.css';

const cx = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(' ');

export function resolveParallaxBgUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return getCompressedAssetUrl(normalized);
}

export const ParallaxBackgroundImg = forwardRef<
  HTMLImageElement,
  ComponentPropsWithoutRef<'img'>
>(function ParallaxBackgroundImg({ className, alt = '', ...rest }, ref) {
  return (
    <img
      ref={ref}
      alt={alt}
      className={cx(styles.parallaxBackgroundImg, className)}
      {...rest}
    />
  );
});

interface ResponsiveParallaxBackgroundImagesProps {
  src: ResponsiveParallaxBg;
}

export const ResponsiveParallaxBackgroundImages: React.FC<
  ResponsiveParallaxBackgroundImagesProps
> = ({ src }) => (
  <>
    <div className={styles.bgImageMobile} aria-hidden>
      <ParallaxBackgroundImg
        src={resolveParallaxBgUrl(src.mobile)}
        alt=""
        decoding="async"
      />
    </div>
    <div className={styles.bgImageDesktop} aria-hidden>
      <ParallaxBackgroundImg
        src={resolveParallaxBgUrl(src.desktop)}
        alt=""
        decoding="async"
      />
    </div>
  </>
);
